// extracted by mini-css-extract-plugin
export default {"header":"HeaderBanner_header__W4KB4","headerContent":"HeaderBanner_headerContent__ZpJPB","titleHeader":"HeaderBanner_titleHeader__OjXXb"};